import React from 'react';
import { baseUrl } from '@plecto/models';

const BaseUrlContext = React.createContext(baseUrl);
export default BaseUrlContext;
